import {HttpException} from "./http.exception.js";

/**
 * 502 Bad Gateway Exception
 */
export class BadGatewayException extends HttpException {
    constructor(message: string = "Bad Gateway", errorBody?: unknown, cause?: Error) {
        super(502, message, errorBody, cause);
    }
}
